import { render } from "./BubbleWindowBase.vue?vue&type=template&id=c3ba735e&scoped=true"
import script from "./BubbleWindowBase.vue?vue&type=script&lang=js"
export * from "./BubbleWindowBase.vue?vue&type=script&lang=js"

import "./BubbleWindowBase.vue?vue&type=style&index=0&id=c3ba735e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c3ba735e"

export default script